import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { COLORS } from '@gc-npm/utils.enums.colors';
import TextInfo,
{
  TEXT_KIND,
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_FONT_WEIGHT,
  TEXT_ALIGN,
} from '@gc-npm/components.text';
import sendGaEvent from '@gc-npm/utils.metrics.send-ga-component-event';
import Price, { PRICE_DECORATION, PRICE_FONT_WEIGHT, PRICE_SIZE } from '@gc-npm/components.price';
import Label, { LABEL_TYPES } from '@gc-npm/components.cms-block.cms-label';
import { actions as modalActions } from '@gc-npm/reducers.modals-reducer';

import Form from '@/components/FormSkeleton';
import { actions as uiActions } from '@/reducers/ui';
import { CONFIRMATION_STATUS, CONFIRMATION_TYPES, PUSSUB_STATES_DICTIONARY } from '@/utils/constants';
import RetenModalForm from './RetenModalForm';
import Glyph from '@gc-npm/components.icon-glyph';

export const COMPONENT_NAME = 'RetenModal';
const TARGET_RETENTION_KIND = 'target';

const RetenModal = ({
  data,
  onClick,
  componentProduct,
}) => {
  const {
    productName,
    promotions,
  } = data || {};
  const dispatch = useDispatch();
  const [activePromo, setActivePromo] = useState(0);

  const {
    claim,
    promoText,
    promoHiredText,
    title,
    description,
    bandaPromo,
    price,
    promoPrice,
    postPrice,
    textPrice,
    promoUrlLegal,
    legalLinkText,
    legalText,
    cancelText,
    acceptText,
    keepText,
    keepStatus,
    upDescription,
    promoTextExtra,
    accumulatedPromos,
    totalDiscount,
    priceSign,
    isHired,
    promoCode,
  } = promotions?.[activePromo] || {};
  const isPricePresent = (value) => (
    value !== null
    && value !== undefined
    && (typeof value !== 'string' || value.trim() !== '')
  );
  const hasPrice = isPricePresent(price);
  const hasPromoPrice = isPricePresent(promoPrice);
  const hasPostPrice = isPricePresent(postPrice);
  const currentPrice = hasPrice ? price : promoPrice;
  const hasCurrentPrice = hasPrice || hasPromoPrice;
  const displayedPrice = hasCurrentPrice ? currentPrice : postPrice;
  const hasDiscount = hasCurrentPrice && hasPostPrice;
  const isTargetPromotion = promotions?.[activePromo]?.kind === TARGET_RETENTION_KIND;
  const trackedPromoCodes = Array.isArray(promoCode) ? promoCode : [];
  const trackedKind = isTargetPromotion
    ? TARGET_RETENTION_KIND
    : promotions?.[activePromo]?.kind;
  const pubSubStateMessage = `Reten_promo:${isTargetPromotion ? 'target:' : ''}${trackedPromoCodes.join('-')}`;
  const text = isHired && promoHiredText ? promoHiredText : promoText;
  const submitText = isHired && keepText ? keepText : acceptText;
  const dismissText = cancelText;

  useEffect(() => {
    // Añadir * al texto promo si la tiene contratada
    if (isHired) {
      const contenedor = document.getElementById('promoText');
      if (contenedor) {
        // Crear el span con el asterisco
        const asterisco = document.createElement('span');
        asterisco.textContent = '*';
        // asterisco.style.color = '#B22634';
        asterisco.style.fontSize = '28px';
        asterisco.style.fontWeight = '600';
        // Insertar como último hijo del div
        contenedor.appendChild(asterisco);
      }
    }

    if (
      promotions
      && Array.isArray(promotions)
      && promotions.length > 0
    ) {
      

 
  // COMPONENT VARIATION → baja_producto_kind_promocode
  const componentVariation = [
    'baja',
    productName || 'no-recuperado',
    trackedKind,
    trackedPromoCodes.join('-')
  ].filter(Boolean).join('_');

  // COMPONENT NAME → COMPONENT_NAME_kind (si existe)
  const componentNameWithKind = [
    COMPONENT_NAME,
    trackedKind
  ].filter(Boolean).join('_');

  dispatch(
    uiActions.sendPubSub({
      state: PUSSUB_STATES_DICTIONARY.PURCHASE.RETENTION.SHOW,
      stateMessage: pubSubStateMessage
    })
  );

  sendGaEvent({
    componentContent: `imprime-retencion-${productName || ''}`,
    componentName: componentNameWithKind,
    componentProduct, // ⬅️ sin tocar
    componentVariation,
    eventType: 'print-success',
  });
}



  }, []);

  const onCancel = () => {
    // siguiente prevention/orderProces
     dispatch(uiActions.sendPubSub({state: PUSSUB_STATES_DICTIONARY.PURCHASE.RETENTION.REJECTED, stateMessage: pubSubStateMessage }));
    if (onClick) {
      onClick();
    }
  }

const sendAcceptedPromotions = () => {
  const acceptedPromotions = promotions.filter((promo) => promo.accept);
  dispatch(uiActions.sendRetentionPromo({
    promotions: acceptedPromotions.map(({ id, kind, promoCode }) => ({ id, kind, promoCode })),
  }));
};

const onSubmit = (isAccept) => {
  if (promotions && promotions[activePromo]) {
    const currentPromo = promotions[activePromo];
    const isContencion = currentPromo.kind === 'contencion';

    currentPromo.accept = isAccept;

    if (isAccept) {
      if (currentPromo.isHired && !isContencion) {
        // pantalla de confirmacion de que le mantenemos la promo
        dispatch(uiActions.sendPubSub({
          state: PUSSUB_STATES_DICTIONARY.PURCHASE.RETENTION.ALREADY_HIRED,
          stateMessage: pubSubStateMessage,
        }));

        const status = CONFIRMATION_STATUS.OK;

        dispatch(
          uiActions.setConfirmation({
            type: CONFIRMATION_TYPES.KEEP,
            status,
            info: keepStatus && keepStatus[status],
          }),
        );

        return;
      }

      dispatch(uiActions.sendPubSub({
        state: PUSSUB_STATES_DICTIONARY.PURCHASE.RETENTION.ACEPTED,
        stateMessage: pubSubStateMessage,
      }));

      sendAcceptedPromotions();

      dispatch(
        modalActions.addModal({
          id: '',
        }),
      );

      return;
    }

    if (promotions[activePromo + 1]) {
      setActivePromo(activePromo + 1);
    } else if (promotions.some((promo) => promo.accept)) {
      dispatch(uiActions.sendPubSub({
        state: PUSSUB_STATES_DICTIONARY.PURCHASE.RETENTION.ACEPTED,
        stateMessage: pubSubStateMessage,
      }));

      sendAcceptedPromotions();

      dispatch(
        modalActions.addModal({
          id: '',
        }),
      );
    } else {
      onCancel();
    }
  } else {
    onCancel();
  }
};

  if (
    !promotions
    || !Array.isArray(promotions)
    || !promotions.length > 0
  ) {
    onCancel();
    return null;
  }
 const onCloseModal = () => {
    dispatch(
      modalActions.addModal({
        id: '',
      }),
    );
  };
  return (
    <>
      <div className="RetenModal">
    
        <div className="RetenModal_infoSection">
          {claim && (
            <div className="RetenModal_infoSection_claim">
              <Label
                text={claim}
                type={LABEL_TYPES.PROMOCION}
              />
            </div>
          )}
          {text && (
            <div className="RetenModal_infoSection_promoText">
              <TextInfo
                text={text}
                color={TEXT_COLOR.GREY6}
                size={TEXT_SIZE.BODY1}
                fontType={TEXT_FONT_WEIGHT.BOLD}
                align={TEXT_ALIGN.LEFT}
              />
            </div>
          )}
          {title && (
            <TextInfo
              text={title}
              color={TEXT_COLOR.GREY6}
              size={TEXT_SIZE.T4}
              fontType={TEXT_FONT_WEIGHT.BOLD}
              align={TEXT_ALIGN.LEFT}
            />
          )}
          {description && (
            <TextInfo
              kind={TEXT_KIND.PARAGRAPH}
              text={description}
              color={TEXT_COLOR.GREY6}
              size={TEXT_SIZE.T5}
              align={TEXT_ALIGN.LEFT}
            />
          )}
          {(hasCurrentPrice || hasPostPrice || totalDiscount) && (
            <div className="RetenModal_infoSection-priceWrapper">
              {bandaPromo && (
                <Label
                  text={bandaPromo}
                  theme={LABEL_TYPES.PROMOCION}
                />
              )}
              {!totalDiscount && (hasCurrentPrice || hasPostPrice) && (
                <div className="RetenModal_infoSection-priceWrapper_prices">
                  {hasDiscount && (
                    <Price
                      fontType={PRICE_FONT_WEIGHT.BOLD}
                      fontTypeUnity={PRICE_FONT_WEIGHT.REGULAR}
                      size={PRICE_SIZE.XL}
                      color={TEXT_COLOR.GREY_6}
                      price={postPrice}
                      decoration={PRICE_DECORATION.LINE_THROUGH}
                      currency="€"
                    />
                  )}
                  <Price
                    fontType={PRICE_FONT_WEIGHT.BOLD}
                    fontTypeUnity={PRICE_FONT_WEIGHT.REGULAR}
                    size={PRICE_SIZE.XL}
                    color={hasPrice || hasPostPrice ? TEXT_COLOR.RED_DARK : TEXT_COLOR.MOVISTAR_BLACK}
                    price={displayedPrice}
                    currency="€"
                    quote="mes"
                  />
                </div>
              )}
              {totalDiscount && (
                <>
                  {
                  accumulatedPromos
                  && Array.isArray(accumulatedPromos)
                  && accumulatedPromos.length > 0
                  && (
                    <div className="RetenModal_infoSection-priceWrapper_accumulatedPromos">
                      {accumulatedPromos.map(({ subject, discount, text }) => {
                        return (
                          <div className="RetenModal_infoSection-priceWrapper_accumulatedPromos--promo">
                            <div className="RetenModal_infoSection-priceWrapper_accumulatedPromos--promo-item">
                              <TextInfo
                                text={subject}
                                color={TEXT_COLOR.GREY6}
                                size={TEXT_SIZE.T4}
                                fontType={TEXT_FONT_WEIGHT.BOLD}
                                align={TEXT_ALIGN.LEFT}
                              />
                              <div className="RetenModal_infoSection-priceWrapper_accumulatedPromos--promo-item__price">
                                <TextInfo
                                  text={priceSign}
                                  color={TEXT_COLOR.RED_DARK}
                                  size={TEXT_SIZE.T1}
                                  align={TEXT_ALIGN.LEFT}
                                />
                                <Price
                                  fontType={PRICE_FONT_WEIGHT.BOLD}
                                  fontTypeUnity={PRICE_FONT_WEIGHT.REGULAR}
                                  size={PRICE_SIZE.M}
                                  color={TEXT_COLOR.RED_DARK}
                                  price={discount}
                                  currency="€"
                                  quote="mes"
                                />
                              </div>
                            </div>
                            <TextInfo
                              text={text}
                              color={TEXT_COLOR.RED_DARK}
                              size={TEXT_SIZE.DISPLAY1}
                              align={TEXT_ALIGN.LEFT}
                            />
                          </div>
                        )
                      })}
                    </div>
                  )
                  }
                  <div className="RetenModal_infoSection-priceWrapper_totalDiscount">
                    {priceSign && (
                      <TextInfo
                        text={priceSign}
                        color={TEXT_COLOR.RED_DARK}
                        size={TEXT_SIZE.T1}
                        align={TEXT_ALIGN.LEFT}
                      />
                    )}
                    <Price
                      fontType={PRICE_FONT_WEIGHT.BOLD}
                      fontTypeUnity={PRICE_FONT_WEIGHT.REGULAR}
                      size={PRICE_SIZE.XL}
                      color={TEXT_COLOR.RED_DARK}
                      price={totalDiscount}
                      currency="€"
                      quote="mes"
                    />
                  </div>
                </>
              )}
              {textPrice && (
                <TextInfo
                  text={textPrice}
                  color={TEXT_COLOR.RED_DARK}
                  size={TEXT_SIZE.CAPTION}
                  align={TEXT_ALIGN.LEFT}
                />
              )}
              {promoTextExtra && (
                <TextInfo
                  text={promoTextExtra}
                  color={TEXT_COLOR.GREY6}
                  size={TEXT_SIZE.CAPTION}
                />
              )}
            </div>
          )}
          {upDescription !== promoTextExtra && (
            <TextInfo
              text={upDescription}
              color={TEXT_COLOR.GREY6}
              size={TEXT_SIZE.CAPTION}
            />
          )}
          {isHired && (
            <div className="RetenModal_infoSection-hiredText">
              <TextInfo
                kind={TEXT_KIND.PARAGRAPH}
                text={isHired}
                color={TEXT_COLOR.GREY6}
                size={TEXT_SIZE.CAPTION3}
                align={TEXT_ALIGN.LEFT}
              />
            </div>
          )}
        </div>
        <div className="RetenModal_formSection">
          {submitText && onSubmit && (
            <Form key={activePromo} id="RetenModalForm">
              <RetenModalForm
                havePromotion={!isHired}
                promoUrlLegal={promoUrlLegal}
                onSubmit={onSubmit}
                productName={productName}
                legalText={legalText}
                legalLinkText={legalLinkText}
                submitText={submitText}
                dismissText={dismissText}
                componentProduct={componentProduct}
                isChecked
              />
            </Form>
          )}
        </div>
      </div>
      <style jsx>
        {`
          .RetenModal {
            width: 798px;
            max-width: 90vw;
            background-color: ${COLORS.white};
            border-radius: 16px;
            padding: 1.5rem;
            gap: 1rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            max-height: 80dvh;
            &_infoSection::-webkit-scrollbar {
              display: none; 
            }
            &_infoSection{
              overflow: scroll;
              display: flex;
              flex-direction: column;
              gap: 1rem;
            &_claim {
              margin: 0 auto;
            }
            &-priceWrapper {
              display: flex;
              flex-direction: column;
              gap: 0.5rem;
              &_prices {
                display: flex;
                gap: 0.5rem;
              }
              &_accumulatedPromos {
                &--promo {
                  &-item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    &__price {
                      display: flex;
                      align-items: center;
                    }
                  }
                }
              }
              &_totalDiscount {
                display: flex;
                align-items: center;
              }
            }
            }
            &-button-container {
              display: flex;
              justify-content: flex-end;
              flex-direction: row-reverse;
            }
          }
          @media screen and (max-width: 768px) {
            
            .RetenModal {
              width: 100vw;
              max-width: 100vw;
              max-height: 90dvh;
              overflow: scroll;
            }
          }
          

        `}
      </style>
    </>
  );
};

export default RetenModal;
